import React from 'react'
import './HeroServices.css';

const HeroServices = () => {
  return (
    <div className='hero'>
        <div className='content'>
            <h1>Services</h1>
            <p>See what we have to offer</p>
        </div>
    </div>
  )
}

export default HeroServices